import React from 'react';
import { IconButton } from '@mui/material';
import { muiIconComponents } from '../constants/editorConstants';

interface ToolbarButtonProps {
  iconKey: string;
  isActive: boolean;
  onClick: () => void;
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({ iconKey, isActive, onClick }) => {
  const IconComponent = muiIconComponents[iconKey];

  if (!IconComponent) {
    return null;
  }

  return (
    <IconButton
      onClick={onClick}
      sx={(theme) => ({
        width: '40px !important',
        height: '40px !important',
        padding: '0 !important',
        borderRadius: '50% !important',
        display: 'flex !important',
        alignItems: 'center !important',
        justifyContent: 'center !important',
        boxSizing: 'border-box !important',
        transition: 'background-color 0.2s ease, color 0.2s ease, border 0.2s ease',
        backgroundColor: 'transparent',
        color: isActive ? theme.palette.primary.main : '#757575',
        border: isActive ? `2px solid ${theme.palette.primary.main}` : `2px solid transparent`,
        '&:hover': {
          backgroundColor: '#f0f0f0 !important',
        },
      })}
    >
      <IconComponent sx={{ width: 22, height: 22 }} />
    </IconButton>
  );
};

export default ToolbarButton;
